import { useEffect, useState } from 'react'
import Table from '../../../../../../global/components/table/Table'
import { ISchedulerStateProps } from '../../container-modal/initialData'
import { Column, Row } from 'react-table'
import { GENERIC_SERVICE } from '../../../../../../global/constants/service'
import { IOrderService } from '../../../../../../../../app/entities/OrderService'

interface IGenericTiresTableProps {
  schedulerState: ISchedulerStateProps
  setSeeGenericTireModal: Function
  setGenericItemIdxToEdit: Function
}

function GenericTiresTable({
  schedulerState,
  setSeeGenericTireModal,
  setGenericItemIdxToEdit,
}: IGenericTiresTableProps) {
  const [tableState, setTableState] = useState({
    data: [] as Row<any>[],
    isLoading: false,
  })

  useEffect(() => {
    setTableState({
      data: (schedulerState.genericItems ??
        []) as unknown as Row<IOrderService>[],
      isLoading: false,
    })
  }, [schedulerState.genericItems])

  if (!schedulerState.genericItems?.length) {
    return <></>
  }

  function onRowClick(row: Row<IOrderService>) {
    const orderService = row.original
    const isGenericService = GENERIC_SERVICE.includes(orderService.label)
    if (isGenericService) {
      const genericTireIndex = row.index
      setGenericItemIdxToEdit(genericTireIndex)
      setSeeGenericTireModal(true)
    }
    //todo add in add wipers modal
  }

  const columns: Column<IOrderService>[] = [
    {
      Header: 'Product',
      accessor: (row) => [row.category, row.description], // Combine category and description
      Cell: ({ value }: { value: string[] }) => {
        return (
          <>
            {value[1]} {value[0].charAt(0).toUpperCase() + value[0].slice(1)}
          </>
        )
      },
    },
    {
      Header: 'Qty.',
      accessor: 'quantity',
    },
    {
      Header: 'Price',
      accessor: 'price',
      Cell: ({ value }) => {
        return <>${value}</>
      },
    },
    {
      Header: 'Cost',
      accessor: 'cost',
      Cell: ({ value }) => {
        if (!value && value !== 0) {
          return <>N/A</>
        }

        return <>${value}</>
      },
    },
  ]

  return (
    <div style={{ width: '100%' }}>
      <Table
        columns={columns}
        data={tableState.data}
        isLoading={tableState.isLoading}
        onRowClick={onRowClick}
        isOpen={true}
        isDisplayMode={true}
        disableSortBy={true}
      />
    </div>
  )
}

export default GenericTiresTable
